import Card from 'assets/components/card/Card';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageSplit from 'assets/components/page/themes/Theme.Page.Split';
import { getLocales } from 'assets/locales/Locale';
import { AccountReceivableInfoTab, useAccountReceivableProvider } from '../Finance.AccountReceivable.Hooks';
import FinanceAccountReceivableInfoDocuments from './info/Finance.AccountReceivable.Info.Documents';
import FinanceAccountReceivableInfoGeneralInfo from './info/Finance.AccountReceivable.Info.GeneralInfo';
import FinanceAccountReceivableInfoNavigation from './info/Finance.AccountReceivable.Info.Navigation';
import FinanceAccountReceivableInfoNotes from './info/Finance.AccountReceivable.Info.Notes';

export default function FinanceAccountReceivableInfo() {
  const { lang, translate } = getLocales();
  const { selected, pageRouter, findApi } = useAccountReceivableProvider();

  return !selected ? null : (
    <Page
      class={ThemePageSplit}
      isLoading={findApi?.isExecuting}
      header={
        <Card
          class={ThemeCardRow}
          media={<Icon class="fas-money-check-alt" />}
          info={translate(selected.statusCode) || lang.noStatusDefined}
          title={selected.dealerDisplayName || `${lang.accountReceivable} #${selected.id}`}
        />
      }
      sidebar={
        <>
          {(!pageRouter.query.infoTab || pageRouter.query.infoTab === AccountReceivableInfoTab.INFO) && (
            <FinanceAccountReceivableInfoGeneralInfo />
          )}
          {pageRouter.query.infoTab === AccountReceivableInfoTab.DOCUMENTS && <FinanceAccountReceivableInfoDocuments />}
          {pageRouter.query.infoTab === AccountReceivableInfoTab.NOTES && <FinanceAccountReceivableInfoNotes />}
        </>
      }
      render={<FinanceAccountReceivableInfoNavigation />}
    />
  );
}
